/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedDTO_PatientManagerIndexDTO_ } from '../models/PaginatedDTO_PatientManagerIndexDTO_'
import type { PatientManagerResponseDTO } from '../models/PatientManagerResponseDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class PatientManagersService {
    /**
     * List Patient Managers
     * Get a paginated list of patient managers.
     * Supports filtering, sorting, and searching across multiple fields.
     * By default, only shows active patient managers (active=true).
     * Organization-level access control is handled by Row Level Security.
     * @returns PaginatedDTO_PatientManagerIndexDTO_ Successful Response
     * @throws ApiError
     */
    public static listPatientManagersPatientManagersGet({
        page = 1,
        limit = 10,
        userId,
        email,
        name,
        active,
        sort,
        search
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Filter by user ID
         */
        userId?: string | null
        /**
         * Filter by email
         */
        email?: string | null
        /**
         * Filter by name
         */
        name?: string | null
        /**
         * Filter by active status (default: true)
         */
        active?: boolean | null
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
        /**
         * Search across name, email, and user ID fields
         */
        search?: string | null
    }): CancelablePromise<PaginatedDTO_PatientManagerIndexDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patient-managers',
            query: {
                page: page,
                limit: limit,
                user_id: userId,
                email: email,
                name: name,
                active: active,
                sort: sort,
                search: search
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Patient Manager
     * Get a patient manager by ID. By default, only returns active patient managers.
     * Organization-level access control is handled by Row Level Security.
     * @returns PatientManagerResponseDTO Successful Response
     * @throws ApiError
     */
    public static getPatientManagerPatientManagersPatientManagerIdGet({
        patientManagerId,
        includeInactive = false
    }: {
        patientManagerId: string
        /**
         * Include inactive (soft deleted) patient managers
         */
        includeInactive?: boolean
    }): CancelablePromise<PatientManagerResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patient-managers/{patient_manager_id}',
            path: {
                patient_manager_id: patientManagerId
            },
            query: {
                include_inactive: includeInactive
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
